import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import styles from "./styles/sport-data.css.js";
import withStyles from "components/with-styles";
import { TextDisplay } from "components/display-data";
import Card from "@material-ui/core/Card";
import I18nBoolean from "components/i18n-boolean";
import { PageHeaderBar } from "components/page";

const MatchPointConfigEventData = ({ event, intl, classes }) => {
  return (
    event &&
    event.matchPointConfig &&
    event.matchPointConfig.ocurrencesSource && (
      <>
        <PageHeaderBar subtitle title="event.sportEventData.matchPointConfig" />
        <div>
          <DataGrid>
            <DataGridItem>
              <Card className={classes.dataCard}>
                <DataGridItem className={classes.column} sizesOverride={{ xl: 6 }}>
                  <>
                    <DataGridItem>
                      <TextDisplay
                        className={classes.data}
                        label={intl.formatMessage({ id: "event.matchPointConfig.ocurrencesSource" })}
                      >
                        <div className={classes.eventExternalData}>
                          {event.matchPointConfig.ocurrencesSource}
                        </div>
                      </TextDisplay>
                    </DataGridItem>
                    <DataGridItem>
                      <TextDisplay
                        className={classes.data}
                        label={intl.formatMessage({ id: "event.matchPointConfig.ocurrencesSourceId" })}
                      >
                        <div className={classes.eventExternalData}>
                          {event.matchPointConfig.ocurrencesSourceId}
                        </div>
                      </TextDisplay>
                    </DataGridItem>
                    <DataGridItem>
                      <TextDisplay
                        className={classes.data}
                        label={intl.formatMessage({ id: "event.matchPointConfig.ocurrencesVisible" })}
                      >
                        <div className={classes.eventExternalData}>
                          <I18nBoolean value={event.matchPointConfig.ocurrencesVisible} />
                        </div>
                      </TextDisplay>
                    </DataGridItem>
                  </>
                </DataGridItem>
              </Card>
            </DataGridItem>
          </DataGrid>
        </div>
      </>
    )
  );
};

MatchPointConfigEventData.propTypes = {
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default withStyles(styles)(injectIntl(MatchPointConfigEventData));
